var path = '/payments/review/review.html';
var html = "<md-card class=\"has-sidebar signup-standard-confirmation\" layout-wrap layout=column layout-gt-sm=row> <md-progress-linear md-mode=indeterminate ng-if=\"review.$loading || review.$pending\"> </md-progress-linear> <article ng-include=\"'/payments/review/_billing.html'\" class=md-block ng-if=\"!review.$loading && !review.$pending\" layout-padding flex=100 flex-gt-sm=60> </article> <aside ng-include=\"'/payments/review/_plan.html'\" class=\"md-block signup-plan\" ng-if=\"!review.$loading && !review.$pending\" layout-padding flex=100 flex-gt-sm=40> </aside> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./payments/review/review.html
// module id = 283
// module chunks = 0